/* Ardor DTF Transfer Designer: engine. Ardor Printing. New Oct 14, 2026 (written for this designer, no theme source in it).
Loaded by sections/ardor-dtf-builder-ws.liquid before assets/ardor-dtf-builder.js. window.ArdorDtfEngine = {
  pack / plan:   copies of one design on a 22 in wide sheet, 1/4 in apart, 1/8 in from every edge, and the cheapest sheet
                 length and sheet count for N copies (prices come from the page's live variants through priceFn);
  arrange / freeSpot / fitLen: gang sheet helpers (shelf packing, the next free spot, the shortest sheet that holds the designs);
  analyze / removeBg / thinCheck: background check, one-click background removal (edge flood fill with a tolerance, then
                 color-to-alpha with feathering), details finer than 0.02 in;
  renderSheet:   the print file, drawn in bands (long sheets are bigger than a browser canvas) into a streaming PNG writer
                 (RGBA, 300 dpi, pHYs) and a PDF copy (one image per band with a soft mask, page = sheet size);
  pngInfo:       width, height, alpha and dpi of a PNG from its first bytes (no decoding). }
Sizes are inches unless a name says px. */
(function (G) {
  'use strict';
  if (G.ArdorDtfEngine) return;

  var SHEET_W = 22, MARGIN = 0.125, GAP = 0.25, LMIN = 3, LMAX = 120, PPI = 300, MAX_SHEETS = 100;
  var TIERS = [1, 2, 3, 5, 10, 25, 50];
  function tierOf(q) { var t = 1; for (var i = 0; i < TIERS.length; i++) if (q >= TIERS[i]) t = TIERS[i]; return t; }
  function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }
  var EPS = 1e-6;

  // ---------- one design, many copies ----------
  function colsFor(dw) { return dw > 0 ? Math.floor((SHEET_W - 2 * MARGIN + GAP + EPS) / (dw + GAP)) : 0; }
  function rowsFor(dh, L) { return dh > 0 ? Math.max(0, Math.floor((L - 2 * MARGIN + GAP + EPS) / (dh + GAP))) : 0; }
  // the shortest whole-inch sheet that holds n copies (Infinity when one copy is too wide)
  function needLen(dw, dh, n) {
    var c = colsFor(dw);
    if (c < 1 || !(n >= 1) || !(dh > 0)) return Infinity;
    var r = Math.ceil(n / c), len = 2 * MARGIN + r * dh + (r - 1) * GAP;
    return Math.max(LMIN, Math.ceil(len - EPS));
  }
  function capacity(dw, dh, L) { return colsFor(dw) * rowsFor(dh, L); }
  // top-left corners of n copies on a sheet of length L: the grid is centred across the width, rows start at the top margin
  function pack(dw, dh, n, L) {
    var c = colsFor(dw), out = [];
    if (c < 1) return { cols: 0, rows: 0, slots: out, x0: MARGIN, fits: false };
    var len = L || needLen(dw, dh, n), r = rowsFor(dh, len), cap = c * r, k = Math.min(n, cap);
    var gw = c * dw + (c - 1) * GAP, x0 = Math.max(MARGIN, (SHEET_W - gw) / 2);
    for (var i = 0; i < k; i++) out.push({ x: x0 + (i % c) * (dw + GAP), y: MARGIN + Math.floor(i / c) * (dh + GAP), w: dw, h: dh });
    return { cols: c, rows: Math.ceil(k / c), slots: out, x0: x0, fits: k === n, len: len, cap: cap };
  }
  // the cheapest way to print n copies: k sheets of the same layout (ceil(n / k) copies each) at length L.
  // priceFn(L, sheets) = price of ONE sheet in cents for that length and sheet count (0 = not sold).
  // Ties: fewer sheets, then the shorter sheet.
  function plan(dw, dh, n, priceFn) {
    n = Math.max(1, Math.round(n) || 1);
    var best = null;
    for (var k = 1; k <= MAX_SHEETS; k++) {
      var per = Math.ceil(n / k);
      if (k > 1 && Math.ceil(n / (k - 1)) === per) continue; // the same layout on more sheets only costs more
      var L = needLen(dw, dh, per);
      if (!(L <= LMAX)) continue;
      var cents = Math.round(priceFn(L, k) || 0);
      if (!(cents > 0)) continue;
      var total = cents * k;
      if (!best || total < best.total || (total === best.total && (k < best.sheets || (k === best.sheets && L < best.len)))) best = { sheets: k, len: L, per: per, cents: cents, total: total };
      if (per === 1) break;
    }
    if (!best) return { ok: false, tooWide: colsFor(dw) < 1, tooMany: colsFor(dw) >= 1 };
    best.ok = true; best.cols = colsFor(dw); best.copies = best.per * best.sheets; best.cap = capacity(dw, dh, best.len);
    // the longest sheet with the same price per sheet (same sheet count): how many copies would fit for the same money
    var Lx = best.len;
    for (var L2 = best.len + 1; L2 <= LMAX; L2++) { if (Math.round(priceFn(L2, best.sheets) || 0) === best.cents) Lx = L2; else break; }
    best.sameLen = Lx; best.sameCap = capacity(dw, dh, Lx);
    return best;
  }

  // ---------- gang sheet ----------
  function overlaps(a, b, gap) { return a.x < b.x + b.w + gap - EPS && b.x < a.x + a.w + gap - EPS && a.y < b.y + b.h + gap - EPS && b.y < a.y + a.h + gap - EPS; }
  // the first free spot for a w x h box, top to bottom then left to right, 1/4 in from the other designs and inside the margin
  function freeSpot(boxes, w, h, L) {
    var step = 0.25, maxY = Math.max(MARGIN, (L || LMAX) - MARGIN - h), maxX = SHEET_W - MARGIN - w;
    if (maxX < MARGIN - EPS) return { x: MARGIN, y: MARGIN, fits: false };
    for (var y = MARGIN; y <= maxY + EPS; y += step) {
      for (var x = MARGIN; x <= maxX + EPS; x += step) {
        var b = { x: x, y: y, w: w, h: h }, hit = false;
        for (var i = 0; i < boxes.length && !hit; i++) if (overlaps(b, boxes[i], GAP)) hit = true;
        if (!hit) return { x: x, y: y, fits: true };
      }
    }
    var bottom = MARGIN; boxes.forEach(function (bx) { bottom = Math.max(bottom, bx.y + bx.h + GAP); });
    return { x: MARGIN, y: bottom, fits: false };
  }
  // the shortest whole-inch sheet that holds every box with the 1/8 in margin
  function fitLen(boxes) {
    var b = 0; boxes.forEach(function (x) { b = Math.max(b, x.y + x.h); });
    return clamp(Math.ceil(b + MARGIN - EPS), LMIN, LMAX);
  }
  // shelf packing, tallest first; a box wider than the sheet is turned when that makes it fit. Returns new positions.
  function arrange(boxes) {
    var useW = SHEET_W - 2 * MARGIN;
    var items = boxes.map(function (b, i) {
      var turn = b.w > useW + EPS && b.h <= useW + EPS;
      return { i: i, w: turn ? b.h : b.w, h: turn ? b.w : b.h, turn: turn };
    }).sort(function (a, b) { return b.h - a.h || b.w - a.w; });
    var x = MARGIN, y = MARGIN, rowH = 0, out = [];
    items.forEach(function (it) {
      if (x > MARGIN && x + it.w > SHEET_W - MARGIN + EPS) { x = MARGIN; y += rowH + GAP; rowH = 0; }
      out[it.i] = { x: x, y: y, w: it.w, h: it.h, turn: it.turn };
      x += it.w + GAP; rowH = Math.max(rowH, it.h);
    });
    return { boxes: out, len: fitLen(out) };
  }

  // ---------- pixels: background, removal, fine details ----------
  function mk(w, h) {
    var c = (typeof OffscreenCanvas !== 'undefined' && !G.document) ? new OffscreenCanvas(w, h) : G.document.createElement('canvas');
    c.width = Math.max(1, Math.round(w)); c.height = Math.max(1, Math.round(h)); return c;
  }
  function pixels(src, maxPx) {
    var w = src.naturalWidth || src.width, h = src.naturalHeight || src.height, k = Math.min(1, Math.sqrt((maxPx || 1e6) / (w * h)));
    var cw = Math.max(1, Math.round(w * k)), ch = Math.max(1, Math.round(h * k)), cv = mk(cw, ch), x = cv.getContext('2d', { willReadFrequently: true });
    x.imageSmoothingEnabled = true; x.imageSmoothingQuality = 'high';
    x.drawImage(src, 0, 0, cw, ch);
    return { w: cw, h: ch, d: x.getImageData(0, 0, cw, ch).data, k: k };
  }
  // the main color of the opaque border pixels (5-bit buckets), and how much of the border it covers
  function borderColor(d, w, h) {
    var bins = {}, n = 0, opaque = 0, clear = 0;
    var add = function (i) {
      n++;
      var a = d[i + 3]; if (a < 16) { clear++; return; }
      if (a < 240) return;
      opaque++;
      var key = (d[i] >> 3) << 10 | (d[i + 1] >> 3) << 5 | (d[i + 2] >> 3), b = bins[key] || (bins[key] = { n: 0, r: 0, g: 0, b: 0 });
      b.n++; b.r += d[i]; b.g += d[i + 1]; b.b += d[i + 2];
    };
    var x, y;
    for (x = 0; x < w; x++) { add(x * 4); add(((h - 1) * w + x) * 4); }
    for (y = 1; y < h - 1; y++) { add(y * w * 4); add((y * w + w - 1) * 4); }
    var top = null;
    Object.keys(bins).forEach(function (k) { if (!top || bins[k].n > top.n) top = bins[k]; });
    if (!top) return { n: n, opaque: opaque, clear: clear, color: null, share: 0 };
    var c = [Math.round(top.r / top.n), Math.round(top.g / top.n), Math.round(top.b / top.n)], near = 0;
    var near1 = function (i) { if (d[i + 3] >= 240 && Math.abs(d[i] - c[0]) + Math.abs(d[i + 1] - c[1]) + Math.abs(d[i + 2] - c[2]) <= 48) near++; };
    for (x = 0; x < w; x++) { near1(x * 4); near1(((h - 1) * w + x) * 4); }
    for (y = 1; y < h - 1; y++) { near1(y * w * 4); near1((y * w + w - 1) * 4); }
    return { n: n, opaque: opaque, clear: clear, color: c, share: near / n };
  }
  function hex(c) { return c ? '#' + c.map(function (v) { return ('0' + v.toString(16)).slice(-2); }).join('').toUpperCase() : ''; }
  // what the picture is like: transparent pixels, a solid background left around the edges, fully opaque
  function analyze(src) {
    var p = pixels(src, 1.2e6), d = p.d, n = p.w * p.h, clear = 0, partial = 0;
    for (var i = 3; i < d.length; i += 4) { if (d[i] < 16) clear++; else if (d[i] < 240) partial++; }
    var bc = borderColor(d, p.w, p.h);
    var solidBg = bc.opaque / Math.max(1, bc.n) > 0.9 && bc.share > 0.8;
    return { w: src.naturalWidth || src.width, h: src.naturalHeight || src.height, transparent: clear / n, partial: partial / n, opaque: clear === 0 && partial === 0,
      solidBg: solidBg, bgColor: hex(bc.color), bgRgb: bc.color, borderOpaque: bc.opaque / Math.max(1, bc.n), borderShare: bc.share };
  }
  // one-click background removal. o: { tolerance 0-100 (default 18), feather px (default 1.5), color '#RRGGBB' (default: the
  // border's main color), everywhere: also clear that color inside the design (letter holes) }. Returns a new canvas of the
  // same size and what it did. Background = pixels joined to the edge whose color is within the tolerance, plus already
  // clear pixels. Pixels next to the background (feather) and soft edges get color-to-alpha, so no halo is left.
  function removeBg(src, o) {
    o = o || {};
    var w = src.naturalWidth || src.width, h = src.naturalHeight || src.height;
    var cv = mk(w, h), x = cv.getContext('2d', { willReadFrequently: true });
    x.drawImage(src, 0, 0);
    var img = x.getImageData(0, 0, w, h), d = img.data, n = w * h;
    var ref = null;
    if (o.color && /^#?[0-9a-f]{6}$/i.test(o.color)) { var v = parseInt(o.color.replace('#', ''), 16); ref = [v >> 16 & 255, v >> 8 & 255, v & 255]; }
    if (!ref) { var bc = borderColor(d, w, h); ref = bc.color; }
    if (!ref) return { canvas: cv, removed: 0, color: '', changed: false }; // the edges are already clear
    var tolPct = clamp(o.tolerance == null ? 18 : +o.tolerance, 0, 100);
    var tol = tolPct / 100 * 441.7; // RGB distance (max = sqrt(3) * 255)
    var tol2 = tol * tol, soft = Math.max(tol * 1.6, tol + 24), soft2 = soft * soft;
    var r0 = ref[0], g0 = ref[1], b0 = ref[2];
    var dist2 = function (i) { var dr = d[i] - r0, dg = d[i + 1] - g0, db = d[i + 2] - b0; return dr * dr + dg * dg + db * db; };
    var bg = new Uint8Array(n), stack = new Int32Array(n), sp = 0;
    var isBg = function (p) { var i = p * 4; return d[i + 3] < 16 || dist2(i) <= tol2; };
    var seed = function (p) { if (!bg[p] && isBg(p)) { bg[p] = 1; stack[sp++] = p; } };
    var X, Y;
    for (X = 0; X < w; X++) { seed(X); seed((h - 1) * w + X); }
    for (Y = 0; Y < h; Y++) { seed(Y * w); seed(Y * w + w - 1); }
    while (sp > 0) {
      var p = stack[--sp], px = p % w;
      if (px > 0) seed(p - 1);
      if (px < w - 1) seed(p + 1);
      if (p >= w) seed(p - w);
      if (p < n - w) seed(p + w);
    }
    if (o.everywhere) for (var q = 0; q < n; q++) if (!bg[q] && dist2(q * 4) <= tol2) bg[q] = 1;
    // feather: pixels within f px of the background (two-pass chamfer distance, capped)
    var f = clamp(o.feather == null ? 1.5 : +o.feather, 0, 6), cap = Math.ceil(f) + 1;
    var dist = new Float32Array(n);
    var big = 1e9;
    for (q = 0; q < n; q++) dist[q] = bg[q] ? 0 : big;
    if (f > 0) {
      for (Y = 0; Y < h; Y++) for (X = 0; X < w; X++) {
        q = Y * w + X; var m = dist[q];
        if (m === 0) continue;
        if (X > 0) m = Math.min(m, dist[q - 1] + 1);
        if (Y > 0) { m = Math.min(m, dist[q - w] + 1); if (X > 0) m = Math.min(m, dist[q - w - 1] + 1.414); if (X < w - 1) m = Math.min(m, dist[q - w + 1] + 1.414); }
        dist[q] = Math.min(m, big);
      }
      for (Y = h - 1; Y >= 0; Y--) for (X = w - 1; X >= 0; X--) {
        q = Y * w + X; var m2 = dist[q];
        if (m2 === 0) continue;
        if (X < w - 1) m2 = Math.min(m2, dist[q + 1] + 1);
        if (Y < h - 1) { m2 = Math.min(m2, dist[q + w] + 1); if (X < w - 1) m2 = Math.min(m2, dist[q + w + 1] + 1.414); if (X > 0) m2 = Math.min(m2, dist[q + w - 1] + 1.414); }
        dist[q] = m2;
      }
    }
    var removed = 0;
    for (q = 0; q < n; q++) {
      var i = q * 4;
      if (bg[q]) { if (d[i + 3]) { d[i + 3] = 0; removed++; } d[i] = d[i + 1] = d[i + 2] = 0; continue; }
      if (!(dist[q] <= f + 0.001) || dist[q] > cap) continue;
      // color-to-alpha against the background color: the least alpha that explains this pixel as color over the background
      var a0 = d[i + 3] / 255, amax = 0, c, k;
      for (k = 0; k < 3; k++) {
        c = d[i + k]; var r = ref[k];
        var ak = c > r ? (c - r) / (255 - r || 1) : (c < r ? (r - c) / (r || 1) : 0);
        if (ak > amax) amax = ak;
      }
      // pixels far from the background color in RGB keep their alpha; near ones fade (soft tolerance band)
      var dd = dist2(i), t = dd >= soft2 ? 1 : Math.max(amax, Math.sqrt(dd) / soft);
      if (t >= 0.999) continue;
      var na = clamp(t, 0, 1);
      if (na < 0.004) { d[i] = d[i + 1] = d[i + 2] = d[i + 3] = 0; removed++; continue; }
      for (k = 0; k < 3; k++) d[i + k] = clamp(Math.round((d[i + k] - ref[k]) / na + ref[k]), 0, 255);
      d[i + 3] = Math.round(255 * na * a0);
    }
    x.putImageData(img, 0, 0);
    return { canvas: cv, removed: removed / n, color: hex(ref), changed: removed > 0, tolerance: tolPct, feather: f, everywhere: !!o.everywhere };
  }
  // lines and specks thinner than minIn (0.02 in) at the printed size wIn: a morphological opening of the ink mask (any
  // visible ink, alpha >= 40) at ppi pixels per inch (default 100, up to 300 for sharp files; 1 px = 1/ppi in). Ink that
  // disappears is thinner than minIn. Returns { checked, thin (share of the ink), px, ppi }.
  function thinCheck(src, wIn, minIn, ppiIn) {
    minIn = minIn || 0.02;
    var w0 = src.naturalWidth || src.width, h0 = src.naturalHeight || src.height, hIn = wIn * h0 / w0;
    var ppi = clamp(ppiIn || 100, 50, 300);
    if (wIn * hIn * ppi * ppi > 9e6) ppi = Math.sqrt(9e6 / (wIn * hIn));
    if (!(ppi >= 50)) return { checked: false, reason: 'too big to check' };
    var r = Math.max(1, Math.round(minIn / 2 * ppi));
    var w = Math.max(3, Math.round(wIn * ppi)), h = Math.max(3, Math.round(hIn * ppi));
    var cv = mk(w, h), x = cv.getContext('2d', { willReadFrequently: true });
    x.imageSmoothingEnabled = true; x.imageSmoothingQuality = 'high';
    x.drawImage(src, 0, 0, w, h);
    var d = x.getImageData(0, 0, w, h).data, n = w * h, m = new Uint8Array(n), ink = 0, q, X, Y, k;
    cv.width = cv.height = 1;
    for (q = 0; q < n; q++) if (d[q * 4 + 3] >= 40) { m[q] = 1; ink++; }
    if (!ink) return { checked: true, thin: 0, px: 0, ink: 0, ppi: ppi };
    var a = m, b = new Uint8Array(n);
    // erode r times (3 x 3), then grow back r times
    for (k = 0; k < r; k++) {
      b.fill(0);
      for (Y = 1; Y < h - 1; Y++) for (X = 1; X < w - 1; X++) {
        q = Y * w + X;
        b[q] = a[q] & a[q - 1] & a[q + 1] & a[q - w] & a[q + w] & a[q - w - 1] & a[q - w + 1] & a[q + w - 1] & a[q + w + 1];
      }
      var t = a === m ? new Uint8Array(n) : a; a = b; b = t;
    }
    for (k = 0; k < r; k++) {
      b.fill(0);
      for (Y = 0; Y < h; Y++) for (X = 0; X < w; X++) {
        q = Y * w + X;
        if (a[q] || (X > 0 && a[q - 1]) || (X < w - 1 && a[q + 1]) || (Y > 0 && a[q - w]) || (Y < h - 1 && a[q + w]) ||
          (X > 0 && Y > 0 && a[q - w - 1]) || (X < w - 1 && Y > 0 && a[q - w + 1]) || (X > 0 && Y < h - 1 && a[q + w - 1]) || (X < w - 1 && Y < h - 1 && a[q + w + 1])) b[q] = 1;
      }
      var t2 = a; a = b; b = t2;
    }
    var thin = 0;
    for (q = 0; q < n; q++) if (m[q] && !a[q]) thin++;
    return { checked: true, thin: thin / ink, px: thin, ink: ink, ppi: ppi, r: r };
  }
  // ink within the margin of a picture that covers the whole sheet (ready-made sheet files): share of the edge band with ink
  function edgeInk(src, Win, Lin, mIn) {
    var p = pixels(src, 4e6), d = p.d, kx = p.w / Win, ky = p.h / Lin, mx = Math.max(1, Math.round((mIn || MARGIN) * kx)), my = Math.max(1, Math.round((mIn || MARGIN) * ky));
    var hit = 0, tot = 0;
    for (var y = 0; y < p.h; y++) for (var x = 0; x < p.w; x++) {
      if (x >= mx && x < p.w - mx && y >= my && y < p.h - my) { x = p.w - mx - 1; continue; }
      tot++; if (d[(y * p.w + x) * 4 + 3] >= 24) hit++;
    }
    return { share: tot ? hit / tot : 0, px: hit };
  }

  // ---------- PNG header (no decoding) ----------
  function pngInfo(blob) {
    return blob.slice(0, 65536).arrayBuffer().then(function (ab) {
      var u = new Uint8Array(ab), dv = new DataView(ab);
      if (u.length < 33 || u[0] !== 0x89 || u[1] !== 0x50 || u[2] !== 0x4E || u[3] !== 0x47) return null;
      var w = dv.getUint32(16), h = dv.getUint32(20), bits = u[24], ct = u[25], out = { w: w, h: h, bits: bits, colorType: ct, alpha: ct === 4 || ct === 6, dpi: 0 };
      var p = 8;
      while (p + 8 <= u.length) {
        var len = dv.getUint32(p), type = String.fromCharCode(u[p + 4], u[p + 5], u[p + 6], u[p + 7]);
        if (type === 'IDAT' || type === 'IEND') break;
        if (type === 'tRNS') out.alpha = true;
        if (type === 'pHYs' && p + 17 <= u.length && u[p + 16] === 1) out.dpi = Math.round(dv.getUint32(p + 8) * 0.0254 * 100) / 100;
        p += 12 + len;
      }
      return out;
    }).catch(function () { return null; });
  }

  // ---------- CRC-32 and Adler (PNG chunks) ----------
  var CRC = (function () { var t = new Uint32Array(256); for (var n = 0; n < 256; n++) { var c = n; for (var k = 0; k < 8; k++) c = c & 1 ? 0xEDB88320 ^ (c >>> 1) : c >>> 1; t[n] = c >>> 0; } return t; })();
  function crc32(parts) { var c = 0xFFFFFFFF; parts.forEach(function (u) { for (var i = 0; i < u.length; i++) c = CRC[(c ^ u[i]) & 255] ^ (c >>> 8); }); return (c ^ 0xFFFFFFFF) >>> 0; }
  function u32(v) { return new Uint8Array([v >>> 24 & 255, v >>> 16 & 255, v >>> 8 & 255, v & 255]); }
  function ascii(s) { var b = new Uint8Array(s.length); for (var i = 0; i < s.length; i++) b[i] = s.charCodeAt(i) & 255; return b; }
  function chunk(type, data) { var t = ascii(type); return [u32(data.length), t, data, u32(crc32([t, data]))]; }
  // yield to the page between bands without a timer (timers in a background tab are slowed to once a minute)
  function tick() {
    return new Promise(function (r) {
      if (typeof MessageChannel === 'undefined') { setTimeout(r, 0); return; }
      var ch = new MessageChannel(); ch.port1.onmessage = function () { ch.port1.close(); r(); }; ch.port2.postMessage(0);
    });
  }

  // A PNG written row band by row band: rows are filtered (Sub) and streamed through the browser's deflate, so a
  // 6600 x 36000 px sheet never sits in memory uncompressed. 8-bit RGBA, sRGB, pHYs = ppi.
  function PngWriter(w, h, ppi) {
    var self = this;
    this.w = w; this.h = h; this.rowsIn = 0; this.parts = [];
    this.parts.push(new Uint8Array([0x89, 0x50, 0x4E, 0x47, 0x0D, 0x0A, 0x1A, 0x0A]));
    var ih = new Uint8Array(13); ih.set(u32(w), 0); ih.set(u32(h), 4); ih[8] = 8; ih[9] = 6; ih[10] = 0; ih[11] = 0; ih[12] = 0;
    var ppm = Math.round((ppi || PPI) / 0.0254), ph = new Uint8Array(9); ph.set(u32(ppm), 0); ph.set(u32(ppm), 4); ph[8] = 1;
    [].push.apply(this.parts, chunk('IHDR', ih));
    [].push.apply(this.parts, chunk('sRGB', new Uint8Array([0])));
    [].push.apply(this.parts, chunk('pHYs', ph));
    this.cs = new CompressionStream('deflate');
    this.wr = this.cs.writable.getWriter();
    this.buf = []; this.bufLen = 0;
    var rd = this.cs.readable.getReader();
    this.done = (function pump() {
      return rd.read().then(function (r) {
        if (r.done) { self.flush(true); return; }
        self.buf.push(r.value); self.bufLen += r.value.length;
        if (self.bufLen >= 1 << 20) self.flush(false);
        return pump();
      });
    })();
  }
  PngWriter.prototype.flush = function (all) {
    if (!this.bufLen) return;
    var data = new Uint8Array(this.bufLen), p = 0;
    this.buf.forEach(function (b) { data.set(b, p); p += b.length; });
    this.buf = []; this.bufLen = 0;
    var c = chunk('IDAT', data);
    this.parts.push(new Blob(c)); // keep the compressed data as a Blob (the browser can page it out)
  };
  // rgba: getImageData().data for `rows` rows of the full width
  PngWriter.prototype.addRows = function (rgba, rows) {
    var w = this.w, stride = w * 4, out = new Uint8Array(rows * (stride + 1));
    for (var r = 0; r < rows; r++) {
      var si = r * stride, di = r * (stride + 1), any = 0, i;
      for (i = 3; i < stride; i += 4) { if (rgba[si + i]) { any = 1; break; } }
      if (!any) { out[di] = 0; continue; } // a clear row: filter None, all zero
      out[di] = 1; // Sub
      di++;
      for (i = 0; i < 4; i++) out[di + i] = rgba[si + i];
      for (i = 4; i < stride; i++) out[di + i] = (rgba[si + i] - rgba[si + i - 4]) & 255;
    }
    this.rowsIn += rows;
    var wr = this.wr;
    return wr.ready.then(function () { return wr.write(out); });
  };
  PngWriter.prototype.finish = function () {
    var self = this;
    if (this.rowsIn !== this.h) return Promise.reject(new Error('png rows ' + this.rowsIn + ' of ' + this.h));
    return this.wr.close().then(function () { return self.done; }).then(function () {
      [].push.apply(self.parts, chunk('IEND', new Uint8Array(0)));
      return new Blob(self.parts, { type: 'image/png' });
    });
  };

  // ---------- PDF copy of the print file: one page the size of the sheet, the art in bands (RGB + soft mask) ----------
  function deflateBlob(u8) { return new Response(new Blob([u8]).stream().pipeThrough(new CompressionStream('deflate'))).blob(); }
  function PdfSheet(Win, Lin, wpx, hpx, meta) {
    this.Win = Win; this.Lin = Lin; this.wpx = wpx; this.hpx = hpx; this.bands = []; this.meta = meta || {};
  }
  // one band of rows starting at row y0 (only bands with ink are kept)
  PdfSheet.prototype.addBand = function (rgba, w, rows, y0) {
    var n = w * rows, any = false, i;
    for (i = 3; i < rgba.length; i += 4) if (rgba[i]) { any = true; break; }
    if (!any) return Promise.resolve();
    var rgb = new Uint8Array(n * 3), a = new Uint8Array(n);
    for (i = 0; i < n; i++) { var s = i * 4, t = i * 3; rgb[t] = rgba[s]; rgb[t + 1] = rgba[s + 1]; rgb[t + 2] = rgba[s + 2]; a[i] = rgba[s + 3]; }
    var self = this;
    return Promise.all([deflateBlob(rgb), deflateBlob(a)]).then(function (z) { self.bands.push({ y0: y0, rows: rows, w: w, rgb: z[0], a: z[1] }); });
  };
  PdfSheet.prototype.finish = function () {
    var W = this.Win * 72, H = this.Lin * 72, pxIn = this.hpx / this.Lin, parts = [], off = 0, xref = [], self = this;
    var add = function (p) { parts.push(p); off += (p.size != null ? p.size : p.length); };
    var str = function (s) { add(ascii(s)); };
    var num = function (v) { var s = (Math.round(v * 10000) / 10000).toFixed(4).replace(/\.?0+$/, ''); return s === '-0' ? '0' : s; };
    str('%PDF-1.5\n%\xE2\xE3\xCF\xD3\n');
    var objN = 0, obj = function () { return ++objN; };
    var catalog = obj(), pages = obj(), page = obj(), content = obj(), info = obj();
    var imgs = this.bands.map(function () { return { im: obj(), sm: obj() }; });
    var ops = [];
    this.bands.forEach(function (b, k) {
      var hIn = b.rows / pxIn, yTop = b.y0 / pxIn;
      ops.push('q ' + num(W) + ' 0 0 ' + num(hIn * 72) + ' 0 ' + num(H - (yTop + hIn) * 72) + ' cm /Im' + k + ' Do Q');
    });
    var start = function (n) { xref[n] = off; str(n + ' 0 obj\n'); };
    start(catalog); str('<< /Type /Catalog /Pages ' + pages + ' 0 R >>\nendobj\n');
    start(pages); str('<< /Type /Pages /Kids [' + page + ' 0 R] /Count 1 >>\nendobj\n');
    var xo = imgs.map(function (m, k) { return '/Im' + k + ' ' + m.im + ' 0 R'; }).join(' ');
    start(page); str('<< /Type /Page /Parent ' + pages + ' 0 R /MediaBox [0 0 ' + num(W) + ' ' + num(H) + '] /TrimBox [0 0 ' + num(W) + ' ' + num(H) + '] /Resources << /ProcSet [/PDF /ImageC /ImageB] /XObject << ' + xo + ' >> >> /Contents ' + content + ' 0 R >>\nendobj\n');
    var cs = ascii(ops.join('\n'));
    start(content); str('<< /Length ' + cs.length + ' >>\nstream\n'); add(cs); str('\nendstream\nendobj\n');
    var m = this.meta, esc = function (s) { return '(' + String(s || '').replace(/[^\x20-\x7E]/g, '').replace(/[\\()]/g, '\\$&') + ')'; };
    start(info); str('<< /Title ' + esc(m.title || 'Ardor DTF Print File') + ' /Author (Ardor Printing) /Creator (Ardor DTF Designer) /Producer (Ardor DTF Designer) >>\nendobj\n');
    this.bands.forEach(function (b, k) {
      var im = imgs[k];
      start(im.im); str('<< /Type /XObject /Subtype /Image /Width ' + b.w + ' /Height ' + b.rows + ' /ColorSpace /DeviceRGB /BitsPerComponent 8 /Filter /FlateDecode /SMask ' + im.sm + ' 0 R /Interpolate false /Length ' + b.rgb.size + ' >>\nstream\n'); add(b.rgb); str('\nendstream\nendobj\n');
      start(im.sm); str('<< /Type /XObject /Subtype /Image /Width ' + b.w + ' /Height ' + b.rows + ' /ColorSpace /DeviceGray /BitsPerComponent 8 /Filter /FlateDecode /Length ' + b.a.size + ' >>\nstream\n'); add(b.a); str('\nendstream\nendobj\n');
    });
    var xs = off, lines = ['xref', '0 ' + (objN + 1), '0000000000 65535 f '];
    for (var i = 1; i <= objN; i++) lines.push(('0000000000' + xref[i]).slice(-10) + ' 00000 n ');
    str(lines.join('\n') + '\ntrailer\n<< /Size ' + (objN + 1) + ' /Root ' + catalog + ' 0 R /Info ' + info + ' 0 R >>\nstartxref\n' + xs + '\n%%EOF\n');
    return Promise.resolve(new Blob(parts, { type: 'application/pdf' }));
  };

  // ---------- the print file, band by band ----------
  // o: { Win, Lin, ppi, draw(ctx, yTopIn, yBotIn) -> Promise|undefined (ctx is in inches, already offset to the band),
  //      pdf: true for the PDF copy, band: rows per band, onProgress(0..1), title, png: false to skip the PNG,
  //      cancelled(): true to stop }
  function renderSheet(o) {
    var ppi = o.ppi || PPI, w = Math.round(o.Win * ppi), h = Math.round(o.Lin * ppi);
    var bandRows = o.band || Math.max(64, Math.min(1500, Math.floor(48e6 / (w * 4))));
    var png = o.png === false ? null : new PngWriter(w, h, ppi), pdf = o.pdf ? new PdfSheet(o.Win, o.Lin, w, h, { title: o.title }) : null;
    var cv = mk(w, Math.min(bandRows, h)), ctx = cv.getContext('2d', { willReadFrequently: true });
    var y = 0, t0 = Date.now();
    function step() {
      if (y >= h) return Promise.all([png ? png.finish() : null, pdf ? pdf.finish() : null]).then(function (r) { cv.width = cv.height = 1; return { png: r[0], pdf: r[1], w: w, h: h, ppi: ppi, ms: Date.now() - t0 }; });
      if (o.cancelled && o.cancelled()) return Promise.reject(new Error('cancelled'));
      var rows = Math.min(bandRows, h - y);
      if (cv.height !== rows) cv.height = rows;
      ctx.setTransform(1, 0, 0, 1, 0, 0); ctx.clearRect(0, 0, w, rows);
      ctx.imageSmoothingEnabled = true; ctx.imageSmoothingQuality = 'high';
      ctx.setTransform(ppi, 0, 0, ppi, 0, -y);
      return Promise.resolve(o.draw(ctx, y / ppi, (y + rows) / ppi)).then(function () {
        ctx.setTransform(1, 0, 0, 1, 0, 0);
        var data = ctx.getImageData(0, 0, w, rows).data;
        return Promise.all([png ? png.addRows(data, rows) : null, pdf ? pdf.addBand(data, w, rows, y) : null]);
      }).then(function () {
        y += rows;
        if (o.onProgress) { try { o.onProgress(y / h); } catch (e) {} }
        return tick().then(step);
      });
    }
    return step();
  }

  G.ArdorDtfEngine = {
    version: '1.0.0', SHEET_W: SHEET_W, MARGIN: MARGIN, GAP: GAP, LMIN: LMIN, LMAX: LMAX, PPI: PPI, MAX_SHEETS: MAX_SHEETS, TIERS: TIERS,
    tierOf: tierOf, colsFor: colsFor, rowsFor: rowsFor, needLen: needLen, capacity: capacity, pack: pack, plan: plan,
    freeSpot: freeSpot, fitLen: fitLen, arrange: arrange, overlaps: overlaps,
    analyze: analyze, removeBg: removeBg, thinCheck: thinCheck, edgeInk: edgeInk, pngInfo: pngInfo,
    PngWriter: PngWriter, PdfSheet: PdfSheet, renderSheet: renderSheet, crc32: crc32
  };
})(typeof window !== 'undefined' ? window : globalThis);
